<template>
  <div class="data-panel">
    <h3 class="data-title">Enviar Anúncio</h3>
    <div class="data-settings" style="max-width:520px;">
      <div class="data-field">
        <label>Tipo</label>
        <select v-model="annType" class="data-select">
          <option value="info">Info</option>
          <option value="aviso">Aviso</option>
          <option value="urgente">Urgente</option>
        </select>
      </div>
      <div class="data-field">
        <label>Título</label>
        <input v-model="annTitle" type="text" placeholder="Título do anúncio" />
      </div>
      <div class="data-field">
        <label>Mensagem</label>
        <textarea v-model="annMessage" rows="4" style="padding:10px;border:1.5px solid #d1d5db;border-radius:8px;font-size:14px;resize:vertical;outline:none;font-family:inherit;" placeholder="Texto do anúncio..." />
      </div>
      <p v-if="annError" class="data-error">{{ annError }}</p>
      <p v-if="annSuccess" class="data-success">{{ annSuccess }}</p>
      <button class="btn-admin-primary" type="button" :disabled="annSending" @click="sendAnnouncement">
        {{ annSending ? 'Enviando...' : 'Enviar anúncio' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, inject } from 'vue'
import { masterFetch } from '@/store/masterSession'

export default {
  name: 'AdminSysAnnouncementsTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const annTitle = ref('')
    const annMessage = ref('')
    const annType = ref('info')
    const annSending = ref(false)
    const annError = ref('')
    const annSuccess = ref('')

    const sendAnnouncement = async () => {
      annError.value = ''
      annSuccess.value = ''
      if (!annTitle.value || !annMessage.value) {
        annError.value = 'Informe título e mensagem.'
        return
      }
      if (!detail?.value) return
      annSending.value = true
      try {
        await masterFetch('/master/announcements', {
          method: 'POST',
          body: JSON.stringify({
            title: annTitle.value,
            message: annMessage.value,
            type: annType.value,
            targetSystemId: detail.value.systemId
          })
        })
        annSuccess.value = 'Anúncio enviado.'
        annTitle.value = ''
        annMessage.value = ''
      } catch (err: unknown) {
        annError.value = err instanceof Error ? err.message : 'Erro ao enviar.'
      } finally {
        annSending.value = false
      }
    }

    return { annTitle, annMessage, annType, annSending, annError, annSuccess, sendAnnouncement }
  }
}
</script>

<style lang="scss">
/* Shared styles — defined in AdminSysDataTab */
</style>
